import React from 'react';
import ProfessionalHub from './ProfessionalHub';

export default function PTPanel() {
  return <ProfessionalHub requiredType="pt" panelTitle="PT Paneli" />;
}

